// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"1516":"ProductPage","1711":"debug","3759":"echarts","5072":"Cart","5962":"admin/app","6429":"polyfills","6459":"Member","9672":"Admin"}[chunkId] || chunkId) + ".6740.js";
};